import { render } from "./Wells.vue?vue&type=template&id=06934cb1"
import script from "./Wells.vue?vue&type=script&lang=js"
export * from "./Wells.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__